import { useTranslation } from 'react-i18next';

export const keyPrefix = 'role_filters';
export const useFilterRoleTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Название',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Name',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Nombre',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    input: {
      placeholder: 'Nome',
    },
  },
}) as Record<string, unknown>;
